export const CLIENT_ID = "80464504005-is9hs5k58cfqtmt4risftv2fl8995p6o.apps.googleusercontent.com";
export const SCOPES = "https://www.googleapis.com/auth/calendar.calendars.readonly https://www.googleapis.com/auth/calendar.app.created https://www.googleapis.com/auth/calendar.freebusy  https://www.googleapis.com/auth/calendar.events.freebusy";
export const DISCOVERY_DOCS = [
    "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"
]
